import request from '@/util/request'

// 注册-报项职位列表（按赛事+小项匹配，仅启用）
export const competitionItemPositionListReg = (data) => {
  return request({
    url: `/api/register/competition/item/position/list`,
    method: 'GET',
    data
  })
}
